import { images } from "@/config/site";
import { brandName } from "@/data/brands";

// DEMO DATA — clearly marked. No real inventory, prices are illustrative
// until actual stock is supplied by the business.
const raw = [
  {
    id: "1", slug: "iphone-15-128gb-blue", brand: "apple", model: "iPhone 15",
    category: "smartphone", type: "used", storage: "128GB", color: "Blue",
    price: 48999, image: images.phoneBlue, isFeatured: true, availability: "In Store",
    description: "A clean, well-kept iPhone 15 in Blue. Smooth performance, excellent display and a dependable camera system for everyday use.",
    accessories: ["Charging cable", "Box"],
    used: { condition: "Excellent", batteryHealth: 92, warrantyMonths: 3, billAvailable: true, physicalCondition: "Minor signs of use" },
  },
  {
    id: "2", slug: "samsung-galaxy-s24-ultra-256gb-black", brand: "samsung", model: "Galaxy S24 Ultra",
    category: "smartphone", type: "new", storage: "256GB", color: "Titanium Black",
    price: 129999, image: images.phoneBlack, isFeatured: true, availability: "In Store",
    description: "The Galaxy S24 Ultra with a built-in S-Pen, a pro-grade camera system and a brilliant large display for work and play.",
    accessories: ["Charging cable", "S-Pen", "Box"],
  },
  {
    id: "3", slug: "iphone-14-128gb-silver", brand: "apple", model: "iPhone 14",
    category: "smartphone", type: "used", storage: "128GB", color: "Silver",
    price: 39999, image: images.phoneSilver, isFeatured: true, availability: "In Store",
    description: "A tidy pre-owned iPhone 14 in Silver. Great battery health and a reliable everyday performer.",
    accessories: ["Charging cable"],
    used: { condition: "Good", batteryHealth: 88, warrantyMonths: 3, billAvailable: false, physicalCondition: "Light scuffs on frame" },
  },
  {
    id: "4", slug: "oneplus-12-256gb-green", brand: "oneplus", model: "OnePlus 12",
    category: "smartphone", type: "new", storage: "256GB", color: "Flowy Emerald",
    price: 64999, image: images.phoneGreen, isFeatured: true, availability: "In Store",
    description: "Flagship OnePlus 12 with fast charging, a smooth high-refresh display and strong day-long performance.",
    accessories: ["Charging cable", "Adapter", "Box"],
  },
  {
    id: "5", slug: "google-pixel-8-128gb-rose", brand: "google", model: "Pixel 8",
    category: "smartphone", type: "used", storage: "128GB", color: "Rose",
    price: 42999, image: images.phonePink, isFeatured: true, availability: "In Store",
    description: "Pre-owned Pixel 8 with an outstanding camera and clean software. Well maintained and ready to go.",
    accessories: ["Charging cable", "Box"],
    used: { condition: "Excellent", batteryHealth: 95, warrantyMonths: 3, billAvailable: true, physicalCondition: "Like new" },
  },
  {
    id: "6", slug: "iphone-15-pro-256gb-gold", brand: "apple", model: "iPhone 15 Pro",
    category: "smartphone", type: "new", storage: "256GB", color: "Gold Titanium",
    price: 134999, image: images.phoneGold, isFeatured: true, availability: "In Store",
    description: "iPhone 15 Pro in a premium titanium finish, with the powerful pro camera system and a stunning ProMotion display.",
    accessories: ["USB-C cable", "Box"],
  },
  {
    id: "7", slug: "samsung-galaxy-s23-256gb-black", brand: "samsung", model: "Galaxy S23",
    category: "smartphone", type: "used", storage: "256GB", color: "Phantom Black",
    price: 44999, image: images.phoneBlack, isFeatured: false, availability: "In Store",
    description: "A compact, powerful pre-owned Galaxy S23 in Phantom Black with excellent battery health.",
    accessories: ["Charging cable"],
    used: { condition: "Excellent", batteryHealth: 90, warrantyMonths: 3, billAvailable: true, physicalCondition: "Minor signs of use" },
  },
  {
    id: "8", slug: "oneplus-11-128gb-blue", brand: "oneplus", model: "OnePlus 11",
    category: "smartphone", type: "used", storage: "128GB", color: "Titan Blue",
    price: 34999, image: images.phoneBlue, isFeatured: false, availability: "In Store",
    description: "Great-value pre-owned OnePlus 11 with fast charging and smooth performance.",
    accessories: ["Charging cable", "Adapter"],
    used: { condition: "Good", batteryHealth: 86, warrantyMonths: 3, billAvailable: false, physicalCondition: "Visible wear on edges" },
  },
];

export const products = raw.map((p) => ({ ...p, brandName: brandName(p.brand) }));

export const getProductBySlug = (slug) => products.find((p) => p.slug === slug);

export const formatPrice = (n) =>
  `₹${new Intl.NumberFormat("en-IN").format(n)}`;

export const featuredNew = products.filter((p) => p.type === "new" && p.isFeatured);
export const featuredUsed = products.filter((p) => p.type === "used" && p.isFeatured);
